import { Link } from "react-router-dom";
import { siteInfo, statsList } from "@/mocks/site";

export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20radar%20scope%20connected%20to%20a%20timeline%20of%20glowing%20nodes%20and%20scattered%20documents%2C%20deep%20charcoal%20warm%20background%20with%20crimson%20and%20amber%20light%20accents%2C%20cinematic%20documentary%20mood%2C%20minimal%20composition%2C%20textured%20paper%20grain%2C%20no%20text%2C%20no%20faces&width=1800&height=1000&seq=hero-baoliao-2026&orientation=landscape"
          alt="抽象的事件追踪与时间线可视化背景图"
          title="爆料网上 - 热点事件始末追踪与真相梳理"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/65 via-foreground-950/60 to-foreground-950/85" />
      </div>

      <div className="relative z-10 w-full px-5 md:px-10 pt-28 pb-16 md:pt-32 md:pb-20">
        <div className="max-w-4xl mx-auto text-center animate-rise">
          <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full border border-background-50/30 bg-background-50/10 backdrop-blur-sm text-xs md:text-sm text-background-50">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-pulse-dot" />
            本周新增 12 条时间线节点 · 持续更新中
          </span>

          <h1 className="mt-6 font-heading font-black text-background-50 text-3xl sm:text-4xl md:text-6xl leading-[1.15]">
            {siteInfo.name}
            <span className="block mt-3 text-xl sm:text-2xl md:text-3xl font-bold text-accent-200">
              事件真相 · 始末追踪
            </span>
          </h1>

          <p className="mt-6 text-sm md:text-lg leading-relaxed text-background-100/90 max-w-2xl mx-auto">
            从事件发生、舆情发酵，到各方回应与后续反转，我们把零散的进展整理成一条清晰的时间线，
            让你不必翻遍几十条消息，也能看清全貌。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/events"
              className="inline-flex w-full sm:w-auto items-center justify-center gap-2 px-6 py-3 rounded-md text-sm md:text-base font-medium whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-list-check-2" />
              浏览全部事件
            </Link>
            <Link
              to="/#tips"
              className="inline-flex w-full sm:w-auto items-center justify-center gap-2 px-6 py-3 rounded-md text-sm md:text-base font-medium whitespace-nowrap border border-background-50/40 text-background-50 hover:bg-background-50/10 transition-colors cursor-pointer"
            >
              <i className="ri-upload-2-line" />
              我要提供线索
            </Link>
          </div>
        </div>

        <div className="mt-12 md:mt-16 max-w-4xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {statsList.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-50/20 bg-background-50/5 backdrop-blur-sm px-4 py-4 text-center"
            >
              <p className="font-heading text-xl md:text-2xl font-bold text-background-50">
                {stat.value}
                <span className="text-accent-300 text-base">{stat.suffix}</span>
              </p>
              <p className="mt-1 text-[11px] md:text-xs text-background-200/80">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}